export default __webpack_public_path__ + "static/media/workfields001.9610e05f.jpg";